/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntCalculationDataTransferObject
 */
export interface IntCalculationDataTransferObject {
    /**
     * 
     * @type {number}
     * @memberof IntCalculationDataTransferObject
     */
    percentageChangeAgainstPreviousPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof IntCalculationDataTransferObject
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof IntCalculationDataTransferObject
     */
    valuePreviousPeriod?: number;
    /**
     * int>
     * @type {{ [key: string]: number; }}
     * @memberof IntCalculationDataTransferObject
     */
    valueGranular?: { [key: string]: number; };
    /**
     * int>
     * @type {{ [key: string]: number; }}
     * @memberof IntCalculationDataTransferObject
     */
    valueGranularPreviousPeriod?: { [key: string]: number; };
}

/**
 * Check if a given object implements the IntCalculationDataTransferObject interface.
 */
export function instanceOfIntCalculationDataTransferObject(value: object): value is IntCalculationDataTransferObject {
    return true;
}

export function IntCalculationDataTransferObjectFromJSON(json: any): IntCalculationDataTransferObject {
    return IntCalculationDataTransferObjectFromJSONTyped(json, false);
}

export function IntCalculationDataTransferObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntCalculationDataTransferObject {
    if (json == null) {
        return json;
    }
    return {
        
        'percentageChangeAgainstPreviousPeriod': json['percentageChangeAgainstPreviousPeriod'] == null ? undefined : json['percentageChangeAgainstPreviousPeriod'],
        'value': json['value'] == null ? undefined : json['value'],
        'valuePreviousPeriod': json['valuePreviousPeriod'] == null ? undefined : json['valuePreviousPeriod'],
        'valueGranular': json['valueGranular'] == null ? undefined : json['valueGranular'],
        'valueGranularPreviousPeriod': json['valueGranularPreviousPeriod'] == null ? undefined : json['valueGranularPreviousPeriod'],
    };
}

export function IntCalculationDataTransferObjectToJSON(json: any): IntCalculationDataTransferObject {
    return IntCalculationDataTransferObjectToJSONTyped(json, false);
}

export function IntCalculationDataTransferObjectToJSONTyped(value?: IntCalculationDataTransferObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'percentageChangeAgainstPreviousPeriod': value['percentageChangeAgainstPreviousPeriod'],
        'value': value['value'],
        'valuePreviousPeriod': value['valuePreviousPeriod'],
        'valueGranular': value['valueGranular'],
        'valueGranularPreviousPeriod': value['valueGranularPreviousPeriod'],
    };
}

